import { useAppContext } from "../../../../AppProvider";
import SyncSelect from "../../../Selects/SyncSelect/SyncSelect";

export const SelectFilter = ({ filter, value, onChange, isDisabled }) => {
  const { dictionary } = useAppContext();

  return (
    <SyncSelect
      name={filter.fieldName}
      onChange={(name, value) => {
        if (value) {
          value = Array.isArray(value) ? value : [value];
        } else {
          value = [];
        }
        onChange(name, value);
      }}
      optionValue={filter.optionValue}
      optionName={filter.optionName}
      options={filter.options}
      isMulti={filter.isMulti}
      value={value}
      placeholder={dictionary.actions.select}
      optionStyle={filter.optionStyle}
      closeMenuOnSelect={!filter.isMulti}
      isClearable={true}
      isDisabled={isDisabled}
      loadOptions={filter.loadOption}
    />
  );
};
